
<template>
  <vs-popup class="holamundo" title="استعلام تراکنش" :active.sync="popupActive">
    <form @keyup.enter="TransactionInquiry">
      <div class="vx-row mb-2">
        <div class="vx-col w-full mb-2">
          <vs-input
            inputmode="numeric"
            class="w-full ltr-input"
            label-placeholder="شماره ارجاع"
            v-model="referenceNumber"
          />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full flex">
          <vs-button
            class="mb-2"
            @click="TransactionInquiry"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-send"
            >استعلام</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style scoped>
[dir="rtl"] tr td:last-child {
  direction: ltr;
  text-align: right;
}
</style>

<script>
export default {
  name: "transaction-inquiry",
  props: {},
  data() {
    return {
      transactionId: null,
      popupActive: false,
      referenceNumber: "",
    };
  },
  methods: {
    inquiry(transactionId, state) {
      if (!transactionId) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "تراکنش مورد نظر یافت نشد",
        });
        return;
      }
      this.transactionId = transactionId;
      this.referenceNumber = "";
      this.TransactionInquiry();
    },
    TransactionInquiry() {
      let loading = this.$vs.loading();
      let payload = {
        transactionId: this.transactionId,
      };
      if (this.referenceNumber) payload.referenceNumber = this.referenceNumber;
      this.$http
        .post("/api/services/app/Behpardakht/TransactionInquiry", payload)
        .then((response) => {
          if (response.data.success == true) {
            if (response.data.result == "ReferenceNumber Is Null") {
              this.popupActive = true;
            } else {
              this.popupActive = false;
              this.$vs.notify({
                time: 5000,
                color: "success",
                title: "موفق!",
                text: response.data.result,
              });
              this.$emit("success");
            }
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
  mounted() {},
};
</script>
